module.exports = __webpack_public_path__ + "img/hk01-20201209.d4dda94b.jpg";